import {
  CombinedGraphQLErrors,
  ServerError,
  ServerParseError,
} from '@apollo/client/errors';

export class HttpError {
  // An AppSync authorizer denial (e.g. an expired MSAL token) arrives as a
  // ServerError/ServerParseError (Apollo Client 4's network-error types,
  // exposing statusCode rather than status) or as a CombinedGraphQLErrors
  // entry with an UNAUTHENTICATED extension code, not as a status on the
  // response, so it otherwise falls through to a generic "something went
  // wrong" message.
  static isUnauthorized(err: any): boolean {
    if (ServerError.is(err) || ServerParseError.is(err)) {
      return err.statusCode === 401 || err.statusCode === 403;
    }

    const status = err?.networkError?.statusCode ?? err?.networkError?.status ?? err?.status;
    if (status === 401 || status === 403) {
      return true;
    }

    if (CombinedGraphQLErrors.is(err)) {
      return err.errors.some(
        (i: any) =>
          i?.errorType === 'UnauthorizedException' ||
          i?.extensions?.code === 'UNAUTHENTICATED',
      );
    }

    return (err?.graphQLErrors ?? []).some(
      (i: any) =>
        i?.errorType === 'UnauthorizedException' ||
        i?.extensions?.code === 'UNAUTHENTICATED',
    );
  }
}
